import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { combineLatest, Observable } from 'rxjs';
import { debounceTime, map, startWith } from 'rxjs/operators';
import { QualityControlInspectionDataDetailsService } from '../data-measurement.service';
import { InspectionMeasureType } from 'src/app/api/elite/types/inspection-assembly-item';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { QualityControlInspectionDataDetailsTypes } from '../data-measurement.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

@Component({
  selector: 'app-qc-ins-form-measure-values',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    NgxMatSelectSearchModule,
  ],
  templateUrl: './form-measure-values.component.html',
  styleUrls: ['./form-measure-values.component.sass'],
})
export class QualityControlInspectionDataFormMeasureValuesComponent
  implements OnInit
{
  readonly dialogData: QualityControlInspectionDataDetailsTypes['data'] =
    inject(MAT_DIALOG_DATA);
  private readonly dataMeasurementService = inject(
    QualityControlInspectionDataDetailsService
  );

  @Input() showDeleteButton = true;
  @Input() form: FormGroup<{
    min: FormControl<number>;
    max: FormControl<number>;
    expected: FormControl<number>;
    type: FormControl<string>;
    toolType: FormControl<number>;
    timesToMeasure: FormControl<number>;
    searchType: FormControl<string>;
  }>;

  showTimesToMeasure = this.dialogData.showTimesToMeasure;

  @Output() remove = new EventEmitter();

  measureTypes$: Observable<InspectionMeasureType[]> =
    this.dataMeasurementService.measureTypesSelectableData$.pipe(
      map(({ list, selectable }) => {
        const selection = list.find(
          (el) => el.title === this.form.controls.type.value
        );
        if (selection) {
          selectable = [selection, ...selectable];
        }
        return selectable;
      })
    );

  measureTypesSelectable$: Observable<InspectionMeasureType[]>;

  constructor() {}

  ngOnInit(): void {
    // this.measureTypes$ = combineLatest([
    //   this.dataMeasurementService.measureTypesSelectableData$,
    //   this.form.controls.type.valueChanges.pipe(
    //     startWith(this.form.controls.type.value)
    //   ),
    // ]).pipe(
    //   map(([data, selected]) => {
    //     console.log(data);
    //     return [
    //       ...data.selectable,
    //       data.list.find((el) => el.title === selected),
    //     ];
    //   })
    // );
    this.form.controls.type.valueChanges.subscribe(() => {
      this.dataMeasurementService.onChangeMeasureType();
    });
    this.measureTypesSelectable$ = this.createMeasureTye();
  }

  removeMeasureForm(): void {
    this.remove.emit();
  }

  createMeasureTye(): Observable<InspectionMeasureType[]> {
    return combineLatest([
      this.measureTypes$.pipe(startWith([])),
      this.form.controls.searchType.valueChanges.pipe(
        startWith(''),
        debounceTime(300)
      ),
    ]).pipe(
      map(([measureTypes, search]) => {
        if (!search) {
          return measureTypes;
        }
        return measureTypes.filter((el) =>
          el.title.toLowerCase().includes(search.toLowerCase())
        );
      })
    );
  }
}
